import { useCallback, useEffect, useState } from 'react';
import { hasValue } from '@progress-fe/core';
import _ from 'lodash';
import { useDebouncedCallback } from './useDebouncedCallback';
const DELAY_MS = 250;
const useJsFieldFormData = ({ config, values, onChange, watchPropsChanges }) => {
    const [fieldConfig, setFieldConfig] = useState(config);
    const [fieldValues, setFieldValues] = useState(values);
    const debouncedOnChange = useDebouncedCallback(onChange, DELAY_MS, []);
    useEffect(() => {
        if (watchPropsChanges) {
            setFieldValues(values);
        }
    }, [values, watchPropsChanges]);
    useEffect(() => {
        if (watchPropsChanges) {
            setFieldConfig(config);
        }
    }, [config, watchPropsChanges]);
    // Field values can be changed by user
    const onChangeFieldValues = useCallback((newFieldValues) => {
        const formData = hasValue(fieldConfig)
            ? { fieldConfig: fieldConfig, fieldValues: newFieldValues }
            : { ...newFieldValues };
        setFieldValues(newFieldValues);
        debouncedOnChange(formData);
    }, [fieldConfig, debouncedOnChange]);
    // Field config can not be changed by user
    const onChangeFieldConfig = useCallback((newFieldConfig) => {
        if (!_.isEqual(fieldConfig, newFieldConfig)) {
            setFieldConfig(newFieldConfig ?? null);
        }
    }, [fieldConfig]);
    return { fieldConfig, fieldValues, onChangeFieldValues, onChangeFieldConfig };
};
export { useJsFieldFormData };
//# sourceMappingURL=useJsFieldFormData.js.map